import * as Yup from 'yup';

const required = 'Campo obrigatório';

export default Yup.object({
  email: Yup.string().email('Digite um e-mail válido').required(required),
});
